import { render } from "./Pagine.vue?vue&type=template&id=202211fb"
import script from "./Pagine.vue?vue&type=script&lang=js"
export * from "./Pagine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__